// Global Instructions Rule Applied!
//
// Configuration → Lookup Lists admin models. Shapes mirror
// public.view__lookup_lists / view__lookup_list_details. Details include
// trashed rows — disable-only v1: "disabled" = trashed, reversible from the
// panel.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const LookupListHeaderRowSchema = z
  .object({
    lookup_headers__id: z.string(),
    lookup_headers__category: z.string(),
    lookup_headers__is_active: z.boolean().nullish(),
    prog__detail_count: z.number()
  })
  .strict()

export type LookupListHeaderRow = z.infer<typeof LookupListHeaderRowSchema>

export const LookupListDetailRowSchema = z
  .object({
    lookup_details__id: z.string(),
    lookup_details__header_id: z.string(),
    lookup_details__label: z.string(),
    lookup_details__value: z.string().nullish(),
    lookup_details__sort_order: z.number().nullish(),
    lookup_details__trashed: z.boolean()
  })
  .strict()

export type LookupListDetailRow = z.infer<typeof LookupListDetailRowSchema>

export function validateLookupListHeaderRow(
  data: unknown,
  options?: { isArray?: boolean }
): LookupListHeaderRow | LookupListHeaderRow[] {
  try {
    return validateWithZodSchema(
      LookupListHeaderRowSchema,
      data,
      'lookup list header row',
      options
    ) as LookupListHeaderRow | LookupListHeaderRow[]
  } catch (e) {
    throw new Error(`Lookup list header validation failed: ${e}`)
  }
}

export function validateLookupListDetailRow(
  data: unknown,
  options?: { isArray?: boolean }
): LookupListDetailRow | LookupListDetailRow[] {
  try {
    return validateWithZodSchema(
      LookupListDetailRowSchema,
      data,
      'lookup list detail row',
      options
    ) as LookupListDetailRow | LookupListDetailRow[]
  } catch (e) {
    throw new Error(`Lookup list detail validation failed: ${e}`)
  }
}
